!(function () {
    "use strict";
    var t,
        e = {
            5092: function () {},
            6090: function (t, e, i) {
                i(1517), i(3777), i(4190), i(2359), i(6097), i(7273), i(7415), i(9929), i(7583), i(5122), i(230), i(7268), i(9733);
                var s = i(7367);
                const a = "is-active",
                    n = "is-selected",
                    r = "is-disabled",
                    l = "is-initialised",
                    o = "is-thumbnail-initialised",
                    c = "is-visible",
                    d = "is-hover",
                    u = "carousel-beginning",
                    h = "carousel-end",
                    p = "onVariantChange";
                class m extends CustomEvent {}
                class b {
                    constructor(t) {
                        let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        (this.container = t),
                            (this.updateHistory = e),
                            (this.variantSelector = t.querySelector('[name="id"]')),
                            (this.elementData = t.querySelector("[data-variant-selector-data]")),
                            this.loadData(JSON.parse(this.elementData.innerHTML)),
                            this.variantSelector?.addEventListener("change", this.onInputChanged);
                    }
                    loadData(t) {
                        (this.elementData.innerHTML = JSON.stringify(t)), (this.data = t);
                    }
                    getVariantId() {
                        return parseInt(this.variantSelector?.value);
                    }
                    getVariant() {
                        const t = this.getVariantId();
                        return this.data.variants.find((e) => e.id === t);
                    }
                    setVariantId(t) {
                        if (isNaN(t) || !isFinite(t)) return;
                        if (!this.data.variants.some((e) => e.id === t)) return;
                        if (!this.variantSelector) return;
                        const e = this.getVariant();
                        (this.variantSelector.value = t.toString()),
                        window.location.href.includes("products") &&
                        this.updateHistory &&
                        (t === (0, s.variantFirstAvailableOrDefault)({ variants: this.data.variants }).id ? (0, s.queryReplaceParam)("variant", null) : (0, s.queryReplaceParam)("variant", t.toString())),
                            this.onVariantSelected();
                        const i = this.getVariant(),
                            a = new m(p, { bubbles: !0, cancelable: !1, detail: { oldVariant: e, newVariant: i, variantSelector: this } });
                        this.variantSelector.dispatchEvent(a);
                    }
                    getOptionValues() {
                        const t = {};
                        return (
                            this.data.options.forEach((e) => (t[e] = [])),
                                this.data.variants.forEach((e) => {
                                    e.options.forEach((e, i) => {
                                        const s = this.data.options[i];
                                        -1 === t[s].indexOf(e) && t[s].push(e);
                                    });
                                }),
                                t
                        );
                    }
                    setVariantOption(t, e) {
                        this.getOptionValues();
                        const i = this.getVariant(),
                            s = [];
                        for (let a = 0; a < this.data.options.length; a++) {
                            let n;
                            (n = a === t ? e : i.options[a]), s.push(n);
                        }
                        const a = this.data.variants.find((t) => t.options.every((t, e) => e >= this.data.options.length || s[e] === t));
                        return a ? (this.setVariantId(a.id), a) : null;
                    }
                    onInputChanged = (t) => {
                        this.setVariantId(parseInt(this.variantSelector.value));
                    };
                    onVariantSelected() {}
                    dispose() {
                        this.variantSelector.removeEventListener("change", this.onInputChanged);
                    }
                }
                const g = "[data-swatch]",
                    v = "[data-swatch-object]",
                    f = "[data-swatch-dropdown]",
                    y = "data-swatch-position",
                    _ = "data-value",
                    S = "is-selected";
                class L extends b {
                    constructor(t, e) {
                        super(t, e),
                            (this.swatches = Array.from(t.querySelectorAll(g).values())),
                            this.container.querySelectorAll(v).forEach((t) => {
                                t.addEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(f).forEach((t) => {
                                t.addEventListener("change", this.onDropdownChange);
                            }),
                            this.onVariantSelected();
                    }
                    onSwatchClick = (t) => {
                        const e = this.container.querySelectorAll("[data-swatch-title]"),
                            i = t.currentTarget,
                            s = i.closest(g);
                        let a = i.querySelector("[data-image]"),
                            n = this.container.closest(".o-product-thumbnail")?.querySelector(".o-product-thumbnail__image-container");
                        if (!s) return;
                        const r = parseInt(s.getAttribute(y) || ""),
                            l = i.getAttribute(_),
                            o = i.getAttribute("data-title");
                        o &&
                        e?.forEach((t) => {
                            t.innerText = o;
                        }),
                        !isNaN(r) && l && (a && n && (n.innerHTML = a.innerHTML), this.setVariantOption(r - 1, l));
                    };
                    onDropdownChange = (t) => {
                        const e = t.currentTarget,
                            i = e.closest(g);
                        if (!i) return;
                        const s = parseInt(i.getAttribute(y) || "");
                        isNaN(s) || this.setVariantOption(s - 1, e.value);
                    };
                    onVariantSelected() {
                        const t = this.getVariant();
                        if (
                            t &&
                            (this.swatches.forEach((e) => {
                                const i = parseInt(e.getAttribute(y) || "");
                                if (isNaN(i)) return;
                                const s = t.options[i - 1];
                                e.querySelectorAll(v).forEach((t) => {
                                    if (t.getAttribute(_) === s) {
                                        t.classList.add(S);
                                        let e = t.parentElement;
                                        e && e.classList.add(S);
                                    } else {
                                        t.classList.remove(S);
                                        let e = t.parentElement;
                                        e && e.classList.remove(S);
                                    }
                                });
                                e.querySelectorAll(f).forEach((t) => (t.value = s)),
                                    e.querySelectorAll("[data-swatch-value]").forEach((t) => {
                                        t.textContent = s;
                                    });
                            }),
                                this.container.classList.contains("o-product-thumbnail__footer"))
                        ) {
                            const e = new CustomEvent("updatePricing", { bubbles: !0, cancelable: !1, detail: { variant: t } });
                            this.container.dispatchEvent(e);
                        }
                    }
                    dispose() {
                        super.dispose(),
                            this.container.querySelectorAll(v).forEach((t) => {
                                t.removeEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(f).forEach((t) => {
                                t.removeEventListener("change", this.onDropdownChange);
                            });
                    }
                }
                const E = "is-disabled",
                    A = document.createElement("template");
                A.innerHTML = "\n  <slot></slot>\n";
                class w extends CustomEvent {}
                class q extends HTMLElement {
                    get value() {
                        return this.input ? this.input.valueAsNumber : this.fallbackValue;
                    }
                    set value(t) {
                        null !== this.max && (t = Math.min(this.max, t)), null !== this.min && (t = Math.max(this.min, t)), this.input && (this.input.valueAsNumber = t), (this.fallbackValue = t);
                    }
                    get min() {
                        const t = this.input ? this.input.min : this.fallbackMin;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set min(t) {
                        null === t ? (this.input && (this.input.min = ""), (this.fallbackMin = null)) : (this.input && (this.input.min = t.toString()), (this.fallbackMin = this.fallbackMin));
                    }
                    get max() {
                        const t = this.input ? this.input.max : this.fallbackMax;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set max(t) {
                        null === t ? (this.input && (this.input.max = ""), (this.fallbackMax = null)) : (this.input && (this.input.max = t.toString()), (this.fallbackMax = this.fallbackMin));
                    }
                    get disabled() {
                        return this.hasAttribute("disabled");
                    }
                    set disabled(t) {
                        t ? this.setAttribute("disabled", "disabled") : this.removeAttribute("disabled"), this.updateDisabled();
                    }
                    input = null;
                    btnMinus = null;
                    btnPlus = null;
                    line = null;
                    fallbackValue = 0;
                    fallbackMin = null;
                    fallbackMax = null;
                    constructor() {
                        super();
                        this.attachShadow({ mode: "open" }).appendChild(A.content.cloneNode(!0)),
                            (this.btnMinus = this.querySelector(".is-minus")),
                            (this.btnPlus = this.querySelector(".is-plus")),
                            (this.input = this.querySelector('input[type="number"]')),
                            this.classList.add("o-quantity-selector"),
                            (this.line = this.getAttribute("line")),
                            this.btnMinus?.addEventListener("click", this.onMinusClick),
                            this.btnPlus?.addEventListener("click", this.onPlusClick),
                            this.input?.addEventListener("change", this.onInputChanged),
                            this.updateDisabled();
                    }
                    onPlusClick = (t) => {
                        t.preventDefault(), (this.value += 1), this.onQuantityChanged();
                    };
                    onMinusClick = (t) => {
                        t.preventDefault(), (this.value -= 1), this.onQuantityChanged();
                    };
                    onInputChanged = (t) => {
                        (this.value = this.input?.valueAsNumber || this.value), this.onQuantityChanged();
                    };
                    onQuantityChanged() {
                        if (this.line)
                            try {
                                (0, s.cartChange)({ quantity: this.value, id: this.line });
                            } catch (t) {
                                console.warn(t);
                            }
                        const t = new w("onQtyChange", { bubbles: !0, cancelable: !1, detail: { qtySelector: this, newValue: this.value } });
                        this.dispatchEvent(t);
                    }
                    updateDisabled() {
                        [this.btnMinus, this.btnPlus, this.input].forEach((t) => {
                            var e;
                            this.disabled
                                ? (e = t) && ((e.disabled = !0), e.classList.add("is-disabled"))
                                : ((t) => {
                                    t && ((t.disabled = !1), t.classList.remove("is-disabled"));
                                })(t);
                        }),
                            this.disabled ? this.classList.add("is-disabled") : this.classList.remove("is-disabled");
                    }
                }
                customElements.get("quantity-selector") || customElements.define("quantity-selector", q);
                const M = "[data-label-element]",
                    T = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn"),
                    k = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn [data-label-element]");
                class P {
                    btnAdd = null;
                    btnAddMobile = null;
                    btnAddDesktop = null;
                    qtySelector = null;
                    form = null;
                    swatches = null;
                    rechargeSubscriptionOptionsElement = null;
                    rechargeWidget = null;
                    stickyPrice = null;
                    money = null;
                    compare = null;
                    parentCarousel = null;
                    parentCarouselTiles = null;
                    adding = !1;
                    ogPrice = 0;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t), this.queryChildren(t), this.attachEvents();
                    }
                    queryChildren(t) {
                        (this.btnAdd = t.querySelector("[data-product-form-add]")),
                            (this.btnAddDesktop = this.btnAdd ? this.btnAdd.querySelector(".is-desktop") : null),
                            (this.btnAddMobile = this.btnAdd ? this.btnAdd.querySelector(".is-mobile") : null),
                            (this.qtySelector = t.querySelector("[data-product-form-qty]")),
                            (this.money = t.querySelectorAll("[data-product-money]")),
                            (this.compare = t.querySelectorAll("[data-product-compare-money]")),
                            (this.rechargeSubscriptionOptionsElement = t.querySelector("[data-product-recharge-selling-plans]")),
                            (this.stickyPrice = document.querySelector("[data-sticky-form]")),
                            (this.parentCarousel = document.querySelector("[data-product-gallery-carousel]")),
                            (this.parentCarouselTiles = document.querySelectorAll(".c-product-gallery__media-container")),
                            setTimeout(() => {
                                this.rechargeWidget = document.querySelector(".rc-widget");
                            }, 2e3);
                    }
                    onVariantChange() {
                        if (!this.swatches) return;
                        const t = this.swatches.getVariant(),
                            e = t?.id,
                            i = Array.from(this.parentCarouselTiles).find((t) => t.getAttribute("data-variant") === e.toString());
                        if ((i?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" }), void 0 === t)) return;
                        const { inventory_management: a, inventory_policy: n, inventory_quantity: r, price: l, compare_at_price: o, selling_plan_allocations: c } = t,
                            d = (0, s.cartGetQuantityOfVariant)(t.id);
                        this.qtySelector && (this.qtySelector.max = "shopify" === a && "deny" === n ? (r || 0) - d : null),
                        this.container.classList.contains("c-product-main__form") && (this.updatePriceElements(l, o), this.updateAddToCart(t), this.updateRechargeVariant(c, l, o));
                    }
                    updateRechargeVariant(t, e, i) {
                        const a = this.container.querySelector(".recharge-subscription-widget"),
                            n = a?.querySelector(".subscription-radio"),
                            r = (a?.querySelector(".onetime-radio"), this.container.querySelector('[name="selling_plan"]')),
                            l = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            o = this.container.querySelector(".c-product-form__price"),
                            c = this.container.querySelector(".rc-selling-plans-dropdown__select");
                        0 === t.length
                            ? (this.container?.classList.remove("has-selling-plan"),
                                setTimeout(() => {
                                    r && (r.value = ""), o && (o.innerHTML = `${(0, s.printMoney)(e)}`), l && (l.innerHTML = `${(0, s.printMoney)(e)}`);
                                }, 1e3))
                            : (n.click(), r && (r.value = `${c?.value}`), this.container?.classList.add("has-selling-plan"), this.updateStickyPriceBasedOnSubscription());
                    }
                    updatePriceElements(t, e) {
                        this.money && this.money.forEach((e) => (e.innerText = (0, s.printMoney)(t))),
                        this.compare && (e ? this.compare.forEach((t) => (t.innerText = (0, s.printMoney)(e))) : this.compare.forEach((t) => (t.innerText = "")));
                        const i = document.querySelector(".subscription-radio"),
                            a = document.querySelector(".onetime-radio"),
                            n = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            r = this.container?.querySelector(".c-product-form__price");
                        i && i.classList.contains("rc-radio--active")
                            ? setTimeout(() => {
                                const e = i.querySelector(".rc-radio__label .rc-radio__price"),
                                    l = a.querySelector(".rc-radio__label");
                                let o = Number(t);
                                (o *= 0.9),
                                l && (l.innerText = `One-time purchase ${(0, s.printMoney)(Number(t))}`),
                                e && (e.innerText = `${(0, s.printMoney)(Number(o))}`),
                                n && this.updatePriceValue(n, (0, s.printMoney)(Number(o))),
                                r && this.updatePriceValue(r, (0, s.printMoney)(Number(o)));
                            }, 200)
                            : (n && this.updatePriceValue(n, (0, s.printMoney)(t)), r && this.updatePriceValue(r, (0, s.printMoney)(t)));
                    }
                    updateStickyPriceBasedOnSubscription() {
                        if (!this.rechargeWidget) return;
                        this.rechargeWidget.querySelectorAll('input[type="radio"]').forEach((t) => {
                            t.addEventListener("change", () => {
                                this.updateStickyPriceElement(t);
                            }),
                            t.checked && this.updateStickyPriceElement(t);
                        });
                    }
                    updateStickyPriceElement(t) {
                        const e = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            i = this.container?.querySelector(".c-product-form__price");
                        if ("subscription" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.remove("is-one-time");
                            const a = t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price");
                            let n = a?.innerText;
                            t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price .is-price") && (n = `${(0, s.printMoney)(Number(this.ogPrice))}`), this.updatePriceValue(e, n), this.updatePriceValue(i, n);
                        } else if ("onetime" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.add("is-one-time");
                            const t = document.querySelector("[data-product-money]"),
                                s = t?.innerText;
                            this.updatePriceValue(e, s), this.updatePriceValue(i, s);
                        }
                    }
                    updatePriceValue(t, e) {
                        setTimeout(() => {
                            t && (t.innerText = e || "");
                        }, 200);
                    }
                    updateAddToCart(t) {
                        if (!this.btnAdd) return;
                        const e = (0, s.cartGetQuantityOfVariant)(t.id),
                            { available: i, inventory_policy: a, inventory_management: n, inventory_quantity: r } = t;
                        i ? ("continue" != a && null != n && (r || 0) - e <= 0 ? this.btnAllInCart() : this.btnAvailable()) : this.btnSoldOut();
                    }
                    btnAvailable() {
                        if (this.btnAdd) {
                            if (document.body.classList.contains("c-page--product"))
                                this.btnAdd.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"))), k && (k.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"));
                            else {
                                if (!this.btnAddDesktop || !this.btnAddMobile) return;
                                this.btnAddDesktop.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.quick_add"))),
                                k && (k.innerHTML = (0, s.t)("products.product.quick_add")),
                                    this.btnAddMobile.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart")));
                            }
                            this.btnAdd.classList.remove(r),
                                this.btnAdd.removeAttribute(E),
                                this.btnAdd.removeAttribute("disabled"),
                                (this.btnAdd.disabled = !1),
                            T && (T.classList.remove(r), T.removeAttribute(E), T.removeAttribute("disabled"), (T.disabled = !1));
                        }
                    }
                    btnAllInCart() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(r),
                            this.btnAdd.setAttribute(E, E),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.all_in_cart"))),
                        k && (k.innerHTML = (0, s.t)("products.product.all_in_cart")),
                        T && (T.classList.add(r), T.setAttribute(E, E), T.setAttribute("disabled", "")));
                    }
                    btnSoldOut() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(r),
                            this.btnAdd.setAttribute(E, E),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(M).forEach((t) => {
                                t.innerHTML = (0, s.t)("products.product.sold_out");
                            }),
                        k && (k.innerHTML = (0, s.t)("products.product.sold_out")),
                        T && (T.classList.add(r), T.setAttribute(E, E), T.setAttribute("disabled", "")));
                    }
                    btnAdded() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.added_to_cart"))),
                        k && (k.innerHTML = (0, s.t)("products.product.added_to_cart")),
                            this.btnAdd.classList.remove(r),
                            this.btnAdd.removeAttribute(E),
                            this.btnAdd.removeAttribute("disabled"),
                            (this.btnAdd.disabled = !1),
                        T && (T.classList.remove(r), T.removeAttribute(E), T.removeAttribute("disabled"), (T.disabled = !1)));
                    }
                    btnPending() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(M).forEach((t) => (t.innerHTML = (0, s.t)("products.product.cart_pending"))),
                        k && (k.innerHTML = (0, s.t)("products.product.cart_pending")),
                            (this.btnAdd.disabled = !0),
                        T && (T.disabled = !0));
                    }
                    initSwatches() {
                        this.swatches = new L(this.container, !0);
                    }
                    attachEvents() {
                        this.initSwatches(),
                            this.container.addEventListener(p, () => this.onVariantChange()),
                            setTimeout(() => {
                                this.updateStickyPriceBasedOnSubscription(), this.updateRechargeCustomPercentage();
                            }, 2e3),
                        T &&
                        T.addEventListener("click", (t) => {
                            t.preventDefault(), t.stopPropagation();
                            let e = document.querySelector("[data-product-main] [data-product-form-add]");
                            e && e.click();
                        });
                    }
                    updateRechargeCustomPercentage() {
                        const t = document.querySelector("[data-product-main]"),
                            e = t?.querySelectorAll(".rc-radio__subscription"),
                            i = document?.querySelectorAll(".rc-radio__price");
                        (this.customRetailPercentage = Number(t?.getAttribute("data-custom-percentage"))),
                            (this.customRetailWording = String(t?.getAttribute("data-custom-wording"))),
                            e?.forEach((t) => {
                                this.customRetailPercentage && this.customRetailPercentage > 0 && (t.innerHTML = `${(0, s.t)("products.product.custom_subscribe_save")} ${this.customRetailPercentage}% ${this.customRetailWording}`);
                            }),
                        this.customRetailPercentage &&
                        this.customRetailPercentage > 0 &&
                        i?.forEach((t) => {
                            this.ogPrice = Number(String(t.textContent).replace("$", "").replace(".", ""));
                            const e = 1 - this.customRetailPercentage / 100;
                            let i = this.ogPrice / e / 100;
                            i = Math.round(100 * i) / 100;
                            const a = 100 * Math.ceil(i);
                            t.innerHTML = `\n          <span class="is-price">${(0, s.printMoney)(Number(this.ogPrice))}</span>\n          <span class="is-compare">${(0, s.printMoney)(Number(a))}</span>\n        `;
                        });
                    }
                    reinitialiseSwatches(t) {
                        this.detatchEvents(), this.swatches?.loadData(t), this.attachEvents(), this.onVariantChange();
                    }
                    detatchEvents() {
                        this.swatches?.dispose();
                    }
                }
                const C = "[data-pseudo-variant-wrapper]",
                    I = "[data-swatch-dropdown]",
                    x = ".o-variant-selector__dropdown",
                    H = "[data-selected-pseudo-variant]",
                    V = [];
                class $ {
                    formElement = null;
                    form = null;
                    toggleFormBtns = null;
                    pseudoVariantBtns = null;
                    pseudoVariantLabel = null;
                    pseudoVariantSwatch = null;
                    mainImage = null;
                    mobileMainImage = null;
                    mobilePopup = null;
                    mobilePopupToggles = null;
                    addButton = null;
                    subscribeBtn = null;
                    oneTimeBtn = null;
                    sellingPlans = null;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t),
                            (this.formElement = t.querySelector("[data-product-form]")),
                            (this.toggleFormBtns = t.querySelectorAll("[data-product-form-toggle]")),
                            (this.pseudoVariantBtns = t.querySelectorAll("[data-pseudo-variant]")),
                            (this.pseudoVariantLabel = t.querySelectorAll("[data-pseudo-label]")),
                            (this.pseudoVariantSwatch = t.querySelector("[data-swatch-label]")),
                            (this.mainImage = t.querySelector(".o-product-thumbnail__image-container")),
                            (this.mobileMainImage = t.querySelector(".o-product-thumbnail__mobile-popup-image-container .o-responsive-image-container")),
                            (this.mobilePopup = t.querySelector("[data-mobile-popup-contianer]")),
                            (this.mobilePopupToggles = t.querySelectorAll("[data-mobile-popup-toggle]")),
                            (this.addButton = t.querySelector("[data-product-quick-add]")),
                            (this.subscribeBtn = t.querySelector("[data-subscribe]")),
                            (this.oneTimeBtn = t.querySelector("[data-one-time]")),
                            (this.sellingPlans = t.querySelector("[data-selling-plans]")),
                            (this.customRetailPercentage = Number(t.getAttribute("data-custom-percentage"))),
                        this.sellingPlans && (this.sellingPlanId = this.sellingPlans.value),
                            this.attachEvents();
                    }
                    updateVariantId(t) {}
                    attachEvents() {
                        this.formElement && ((this.form = new P(this.formElement)), this.formElement?.querySelector(I)?.addEventListener("change", this.updateVariantId)),
                            this.mobilePopupToggles?.forEach((t) => {
                                t.addEventListener("click", (t) => this.toggleMobileForme(t));
                            }),
                            this.container?.addEventListener("mouseenter", () => {
                                this.container.classList.add(d);
                            }),
                            this.container?.addEventListener("mouseleave", () => {
                                this.container.classList.remove(d);
                            }),
                        this.pseudoVariantBtns &&
                        Array.from(this.pseudoVariantBtns).forEach((t) => {
                            t.addEventListener("click", (e) => this.handlePseudoVariantClick(e, t));
                        }),
                            this.swatchDropdown(),
                            setTimeout(() => {
                                this.initBadgesCarousel();
                            }, 1e3),
                            this.subscribeBtn?.addEventListener("click", (t) => {
                                this.toggleSubscribe(t);
                            }),
                            this.oneTimeBtn?.addEventListener("click", (t) => {
                                this.toggleOneTime(t);
                            }),
                            this.subscribeBtn ? (this.hasSellingPlan = !0) : (this.hasSellingPlan = !1),
                        this.sellingPlans &&
                        this.sellingPlans.addEventListener("change", () => {
                            this.setSubscriptionPlan();
                        }),
                            this.container.addEventListener("updatePricing", (t) => {
                                this.updatePricing(t);
                            });
                    }
                    toggleMobileForme(t) {
                        t.preventDefault(), this.mobilePopup?.classList.toggle("is-open");
                    }
                    updatePricing(t) {
                        const e = t.detail.variant;
                        let i = "",
                            a = 0,
                            n = 0,
                            r = e.compare_at_price,
                            l = e.price;
                        e.custom_retail_compare && (r = e.custom_retail_compare),
                            e.custom_retail_percentage
                                ? ((this.customRetailPercentage = e.custom_retail_percentage), this.container.classList.add("has-custom-percentage"))
                                : ((this.customRetailPercentage = 0), this.container.classList.remove("has-custom-percentage")),
                        e.custom_retail_wording && (this.customRetailWording = e.custom_retail_wording),
                            e.selling_plan_allocations.forEach((t, e) => {
                                if (0 === e) {
                                    (i += `<option value="${t.selling_plan_id}" selected></option>`), (a = t.price), (n = t.compare_at_price);
                                    const e = this.container?.querySelector("[data-selling-plan-container]");
                                    if (this.hasSellingPlan) {
                                        if (!e) return;
                                        e.innerHTML = `<input name="selling_plan" type="hidden" value="${t.selling_plan_id}">`;
                                    } else {
                                        if (!e) return;
                                        e.innerHTML = "";
                                    }
                                }
                            });
                        const o = this.container.querySelector(".o-variant-selector__dropdown");
                        if (o)
                            for (const t of o.options)
                                if (Number(t.value) === Number(e.id)) {
                                    o.value = t.value;
                                    break;
                                }
                        let c = this.container?.querySelector('input[name="product-id"]');
                        c && (c.value = e.id), this.sellingPlans && (this.sellingPlans.innerHTML = i);
                        const d = this.container?.querySelectorAll(".o-product-thumbnail__pricing.is-subscribe"),
                            u = this.container?.querySelectorAll(".o-product-thumbnail__price-wrapper.is-subscribe"),
                            h = this.container?.querySelectorAll("[data-subscription-price]"),
                            p = this.container?.querySelectorAll("[data-subscription-price-adjusted]"),
                            m = this.container?.querySelectorAll("[data-subscription-percent]"),
                            b = this.container.querySelector(".o-product-thumbnail__inner"),
                            g = this.container?.querySelector(".o-product-thumbnail__badge.is-custom-percentage");
                        let v = ((n - a) / n) * 100,
                            f = "";
                        (f = this.customRetailPercentage && this.customRetailPercentage > 0 ? `\n        <div class="o-product-thumbnail__badge o-paragraph--3 is-custom-percentage">${this.customRetailPercentage}% off</div>\n      ` : ""),
                            g
                                ? "" != f || (b && b.querySelector(".o-product-thumbnail__badge.is-custom-percentage")?.remove())
                                : "" != f
                                    ? b && b.insertAdjacentHTML("afterbegin", f)
                                    : b && b.querySelector(".o-product-thumbnail__badge.is-custom-percentage")?.remove(),
                        m &&
                        m.forEach((t) => {
                            this.customRetailPercentage && this.customRetailPercentage > 0 ? (t.innerHTML = `${this.customRetailPercentage}% ${this.customRetailWording}`) : (t.innerHTML = `${v}%`);
                        }),
                        h &&
                        h.forEach((t) => {
                            t.innerHTML = `${(0, s.printMoney)(Number(n))}`;
                        }),
                        p &&
                        p.forEach((t) => {
                            t.innerHTML = `\n          ${(0, s.printMoney)(Number(a))}\n        `;
                        }),
                        d &&
                        d.forEach((t) => {
                            const e = t.querySelector(".o-pricing__price"),
                                i = t.querySelector(".o-pricing__compare");
                            e && (e.innerHTML = `${(0, s.printMoney)(Number(l))}`), i && (i.innerHTML = r > 0 ? `${(0, s.printMoney)(Number(r))}` : "");
                        }),
                        u &&
                        u.forEach((t) => {
                            const e = t.querySelector(".o-pricing__compare");
                            e && (e.innerHTML = r > 0 ? `${(0, s.printMoney)(Number(r))}` : "");
                        });
                        let y = "";
                        this.mainImage &&
                        this.mobileMainImage &&
                        e.featured_image &&
                        ((y = e.featured_image?.src ? e.featured_image.src : e.featured_image ? e.featured_image : ""), this.updateInitialImage(this.mainImage, y), this.updateInitialImage(this.mobileMainImage, y)),
                            this.checkButtonState(e),
                            this.setSubscriptionPlan(),
                            0 === e.selling_plan_allocations.length
                                ? (this.oneTimeBtn?.click(), this.oneTimeBtn?.parentElement?.classList.add("is-hidden"), this.subscribeBtn?.setAttribute("disabled", "disabled"), this.container.classList.remove("has-selling-plan"))
                                : (this.subscribeBtn?.removeAttribute("disabled"), this.oneTimeBtn?.parentElement?.classList.remove("is-hidden"), this.subscribeBtn?.click(), this.container.classList.add("has-selling-plan"));
                    }
                    updateInitialImage(t, e) {
                        if (!t) return;
                        let i = t.querySelector("picture");
                        if (!i) return;
                        const s = `\n      <picture>\n        <img src="${String(e.replace(".jpg", "_x800.jpg"))}" class="o-responsive-image">\n      </picture>\n    `,
                            a = document.createElement("template");
                        a.innerHTML = s.trim();
                        const n = a.content.firstChild,
                            r = n.querySelector("img");
                        r &&
                        ((n.style.opacity = "0"),
                            i.after(n),
                            i.offsetWidth,
                            (r.onload = () => {
                                (n.style.transition = "opacity 0.5s"), (n.style.opacity = "1"), i?.remove(), (i = n);
                            }));
                    }
                    setSubscriptionPlan() {
                        this.sellingPlanId = String(this.sellingPlans?.value);
                        const t = this.container?.querySelector("[data-selling-plan-container]"),
                            e = `\n      <input name="selling_plan" type="hidden" value="${this.sellingPlanId}">\n    `;
                        if (this.hasSellingPlan) {
                            if (!t) return;
                            t.innerHTML = e;
                        } else {
                            if (!t) return;
                            t.innerHTML = "";
                        }
                    }
                    toggleSubscribe(t) {
                        t.preventDefault();
                        t.currentTarget.classList.add("is-active"), this.oneTimeBtn?.classList.remove("is-active"), (this.hasSellingPlan = !0), this.container.classList.add("has-selling-plan"), this.setSubscriptionPlan();
                    }
                    toggleOneTime(t) {
                        t.preventDefault();
                        t.currentTarget.classList.add("is-active"), this.subscribeBtn?.classList.remove("is-active"), (this.hasSellingPlan = !1), this.container.classList.remove("has-selling-plan"), this.setSubscriptionPlan();
                    }
                    swatchDropdown() {
                        let t = this.formElement?.querySelector(I),
                            e = this.formElement?.querySelector(H);
                        const i = this.formElement?.querySelector(x);
                        t &&
                        t.addEventListener("change", (t) => {
                            t.preventDefault();
                            const s = t.currentTarget;
                            let a = s.options[s.selectedIndex].getAttribute("data-id");
                            e && a && (e.value = a), i && a && (i.value = a);
                        });
                    }
                    handlePseudoVariantClick(t, e) {
                        t.preventDefault();
                        let i = "",
                            s = "",
                            a = "";
                        if (!this.pseudoVariantBtns || void 0 === e) return;
                        const r = this.formElement?.querySelector(H),
                            l = this.formElement?.querySelector("[data-variant-selected-id]"),
                            o = e?.getAttribute("data-pseudo-label"),
                            c = e?.getAttribute("data-product-label"),
                            d = e?.getAttribute("data-pseudo-link"),
                            u = e?.querySelector("[data-pseudo-variants]"),
                            h = this.container.querySelectorAll("[data-thumbnail-title]"),
                            p = this.container.querySelectorAll("[data-thumbnail-link]"),
                            m = e.getAttribute("data-pseudo-variant"),
                            b = this.formElement?.querySelector(I),
                            g = this.formElement?.querySelector(x),
                            v = JSON.parse(u?.innerHTML),
                            f = e.closest(C);
                        Array.from(this.pseudoVariantBtns).forEach((t) => {
                            t.closest(C)?.classList.remove(n);
                        });
                        let y = "",
                            _ = "";
                        if (u) {
                            if (!v) return;
                            v.variants.forEach((t) => {
                                t.custom_retail_percentage
                                    ? ((this.customRetailPercentage = Number(t.custom_retail_percentage)), this.container.classList.add("has-custom-percentage"))
                                    : ((this.customRetailPercentage = 0), this.container.classList.remove("has-custom-percentage")),
                                t.custom_retail_wording && (this.customRetailWording = t.custom_retail_wording),
                                    (_ = t.swatch_image?.src ? t.swatch_image.src : t.swatch_image ? t.swatch_image : ""),
                                    (i += `<option value="${t.handle}" data-id="${t.id}">${t.title}</option>`),
                                    (s += `<option value="${t.id}">${t.title}</option>`),
                                    (a += `\n          <div class="o-swatches__swatch-button-wrap is-image ${t.handle}" data-thumbs-carousel-item="">\n            <button title="${
                                        t.title
                                    }" type="button" class="o-swatches__swatch-button s-swatch--${t.handle} is-selected"\n              data-swatch-object data-value="${t.handle}" data-swatch-position="1" data-title="${
                                        t.title
                                    }">\n              <img class="o-swatches__image o-swatches__image--first" src="${String(_).replace(
                                        ".jpg",
                                        "_100x.jpg"
                                    )}">\n              <img class="o-swatches__image o-swatches__image--second" src="${String(_).replace(".jpg", "_100x.jpg")}">\n            </button>\n          </div>\n        `),
                                    t.selling_plan_allocations.forEach((t, e) => {
                                        if (0 === e) {
                                            y += `<option value="${t.selling_plan_id}" selected></option>`;
                                            const e = this.container?.querySelector("[data-selling-plan-container]");
                                            if (this.hasSellingPlan) {
                                                if (!e) return;
                                                e.innerHTML = `<input name="selling_plan" type="hidden" value="${t.selling_plan_id}">`;
                                            } else {
                                                if (!e) return;
                                                e.innerHTML = "";
                                            }
                                        }
                                    });
                            });
                        }
                        this.sellingPlans && (this.sellingPlans.innerHTML = y),
                        "" != i && b && ((b.innerHTML = i), (g.innerHTML = s)),
                        "" != s && g && (g.innerHTML = s),
                        this.pseudoVariantSwatch && (this.pseudoVariantSwatch.innerHTML = o),
                        h &&
                        h.forEach((t) => {
                            t.innerHTML = c;
                        }),
                        p &&
                        null != d &&
                        p.forEach((t) => {
                            t.setAttribute("href", d);
                        }),
                        r && m && ((r.value = m), l && (l.value = m)),
                            f?.classList.add(n);
                        let S = this.container?.querySelector('input[name="product-id"]');
                        S && (S.value = v.id), this.checkButtonState(v);
                        const L = this.container?.querySelectorAll(".o-swatches__wrapper:not(.is-pseudo)");
                        L.forEach((t) => {
                            1 == v.variants.length
                                ? t.classList.add("is-hidden")
                                : (t.classList.remove("is-hidden"),
                                t.classList.contains("is-select") &&
                                (t.innerHTML = `\n          <div class="o-swatches o-product-thumbnail__swatches" data-swatches>\n            <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>\n              <select name="id" class="o-input o-variant-selector__dropdown">\n                ${s}\n              </select>\n            </div>\n            <div class="o-swatches__swatches has-js">\n              <div class="o-swatches__inner o-swatches__inner-select">\n                <div class="o-swatches__swatch is-select" data-swatch data-swatch-position="1">\n                  <select class="o-swatches__select o-select" name="option-0" data-swatch-dropdown>\n                    ${i}\n                  </select>\n                </div>\n              </div>\n            </div>\n          </div>\n          `),
                                t.classList.contains("is-color") &&
                                (t.innerHTML = `\n          <h6 class="o-swatches__title" data-swatch-title="">Spool and Dispenser</h6>\n            <div class="o-swatches o-product-thumbnail__swatches" data-swatches>\n              <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>\n                <select name="id" class="o-input o-variant-selector__dropdown">\n                  ${s}\n                </select>\n              </div>\n              <div class="o-swatches__swatches has-js">\n                <div class="o-swatches__inner o-swatches__inner-color">\n                  <div class="o-swatches__swatch is-select is-centered" data-swatch="" data-swatch-position="1">\n                    <div class="o-swatches__swatch-options is-color">\n                      ${a}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          `));
                        }),
                            this.form?.reinitialiseSwatches(v);
                    }
                    checkButtonState(t) {
                        const e = this.addButton?.querySelectorAll("[data-label-element]");
                        !0 === t.available
                            ? (this.addButton?.classList.add("is-label-animated"),
                                this.addButton?.classList.remove("is-disabled"),
                                this.addButton?.removeAttribute("disabled"),
                                e?.forEach((t) => {
                                    t.innerHTML = "Quick add";
                                }))
                            : (this.addButton?.classList.remove("is-label-animated"),
                                this.addButton?.classList.add("is-disabled"),
                                this.addButton?.setAttribute("disabled", "disabled"),
                                e?.forEach((t) => {
                                    t.innerHTML = "Out of stock";
                                }));
                    }
                    initBadgesCarousel = () => {
                        const t = "data-resize";
                        this.container.querySelectorAll("[data-thumbs-carousel-container]").forEach((e) => {
                            if (e.classList.contains(l)) return;
                            e.classList.add(l);
                            const i = e.querySelector("[data-thumbs-carousel]"),
                                s = e.querySelector("[data-thumbs-carousel-prev]"),
                                a = e.querySelector("[data-thumbs-carousel-next]"),
                                n = e.querySelectorAll("[data-thumbs-carousel-item]"),
                                r = Number(e.getAttribute("data-gap")),
                                o = e.hasAttribute("data-no-touch"),
                                d = e.querySelector("[data-thumbs-carousel-progress-bar]");
                            if (0 === n.length) return void e.classList.remove(c);
                            e.classList.add(c);
                            let p,
                                m,
                                b,
                                g = 0,
                                v = 0,
                                f = 0,
                                y = 0,
                                _ = 0,
                                S = 0,
                                L = !1;
                            e.classList.add(l);
                            const E = () => {
                                    if (e.hasAttribute("data-thumbs-carousel-disabled-mobile") && window.outerWidth < 750) return;
                                    if (!i) return;
                                    (y = e.clientWidth), (_ = Number(i.clientWidth));
                                    const t = w(0);
                                    S = window.outerWidth >= 750 ? 2 * r : r;
                                    const s = Array.from(n).reduce((e, i) => e + t + S, 0),
                                        a = 3 * t + 2 * S;
                                    (f = Math.max(0, Math.ceil((s - a) / (t + S)))), a < y && (f = Math.max(f, v)), (v = Math.min(f, Math.max(0, v)));
                                    const l = (e) => e * (t + S);
                                    if (_ < y) return e.classList.add(u), e.classList.add(h), void (i.style.transform = "translateX(0)");
                                    l(v) > s - y ? ((L = !0), (m = -(s - y))) : (m = -l(v)), (i.style.transform = `translateX(${m}px)`), q(), A();
                                },
                                A = () => {
                                    if (e.hasAttribute(t) && "true" === e.getAttribute(t)) {
                                        const t = n[v].children[0];
                                        t && i && (i.style.height = `${t.offsetHeight}px`);
                                    }
                                },
                                w = (t) => {
                                    const e = n[t],
                                        i = getComputedStyle(e),
                                        s = parseInt(i.marginLeft || "0"),
                                        a = parseInt(i.marginRight || "0"),
                                        r = parseInt(i.paddingLeft || "0"),
                                        l = parseInt(i.paddingRight || "0");
                                    return e.offsetWidth + s + a + r + l;
                                },
                                q = () => {
                                    (b = (v / f) * 100),
                                    L && (b = 100),
                                    d &&
                                    ((d.style.width = `${b}%`),
                                        b > 0
                                            ? (d.parentElement?.classList.add("is-visible"), d.parentElement?.parentElement?.classList.add("has-progress"))
                                            : (d.parentElement?.classList.remove("is-visible"), d.parentElement?.parentElement?.classList.remove("has-progress"))),
                                        e.classList.toggle(u, 0 === v),
                                        e.classList.toggle(h, L);
                                };
                            s?.addEventListener("click", (t) => {
                                t.preventDefault(), v > 0 && ((L = !1), (v -= 3), (v = Math.max(0, v)), E());
                            }),
                                a?.addEventListener("click", (t) => {
                                    t.preventDefault(), v < f && ((v += 3), (v = Math.min(f, v)), E());
                                }),
                                window.addEventListener("resize", () => {
                                    clearTimeout(p),
                                        (p = setTimeout(() => {
                                            E();
                                        }, 500));
                                }),
                                e.addEventListener(
                                    "touchstart",
                                    (t) => {
                                        o || (g = t.touches[0].clientX);
                                    },
                                    { passive: !0 }
                                ),
                                e.addEventListener(
                                    "touchmove",
                                    (t) => {
                                        if (o) return;
                                        const e = t.touches[0].clientX,
                                            i = e - g;
                                        Math.abs(i) > 70 && (i > 0 && v > 0 ? ((L = !1), (v -= 3), (v = Math.max(0, v))) : i < 0 && v < f && !L && ((v += 3), (v = Math.min(f, v))), E(), (g = e));
                                    },
                                    { passive: !0 }
                                ),
                                E();
                        });
                    };
                    detatchEvents() {
                        this.form && this.form.detatchEvents();
                    }
                }
                const R = () => {
                    [...V].forEach((t) => {
                        t.container || t.detatchEvents();
                    }),
                        document.querySelectorAll("[data-product-thumbnail]").forEach((t) => {
                            t.classList.contains(o) || (t.classList.add(o), new $(t));
                        });
                };
                R();
                const B = (t, e) => {
                        let i = 0;
                        return function () {
                            const s = new Date().getTime();
                            if (s - i >= e) {
                                for (var a = arguments.length, n = new Array(a), r = 0; r < a; r++) n[r] = arguments[r];
                                t.apply(this, n), (i = s);
                            }
                        };
                    },
                    O = (t, e) => {
                        let i;
                        return function () {
                            for (var s = arguments.length, a = new Array(s), n = 0; n < s; n++) a[n] = arguments[n];
                            i && clearTimeout(i),
                                (i = setTimeout(() => {
                                    t.apply(this, a), (i = null);
                                }, e));
                        };
                    },
                    N = "is-animating";
                class D extends HTMLElement {
                    tabActiveIndex = 0;
                    constructor() {
                        super(),
                            (this.tabsWrapper = this.querySelector("[data-tab-wrapper]")),
                            (this.tabsElement = this.querySelectorAll("[data-tab]")),
                            (this.tabActiveIndicator = this.querySelector("[data-tab-indicator]")),
                            (this.firstTabElement = this.tabsElement[0]),
                            (this.tabClickCallback = null),
                            (this.throttledResize = B(this.handleResize.bind(this), 200));
                    }
                    connectedCallback() {
                        null !== this.tabActiveIndicator && this.tabsElement.length > 0 && (this.initializeTabs(), window.addEventListener("resize", this.throttledResize), this.onTabClick({ buttonElement: this.firstTabElement, index: 0 }));
                    }
                    initializeTabs() {
                        this.addClickEventListeners();
                    }
                    addClickEventListeners() {
                        Array.from(this.tabsElement).forEach((t, e) => {
                            t.addEventListener("click", () => this.onTabClick({ buttonElement: t, index: e }));
                        });
                    }
                    setCallback(t) {
                        this.tabClickCallback = t;
                    }
                    onTabClick(t) {
                        let { buttonElement: e, index: i } = t;
                        void 0 !== i && (this.tabActiveIndex = i), null !== e && this.updateIndicatorStyles(e), void 0 !== i && null !== this.tabClickCallback && this.tabClickCallback(i);
                    }
                    handleResize = () => {
                        const t = this.tabsElement[this.tabActiveIndex];
                        t && this.updateIndicatorStyles(t);
                    };
                    updateIndicatorStyles(t) {
                        if (null !== this.tabActiveIndicator && null !== this.tabsWrapper) {
                            this.tabsElement.forEach((t) => {
                                t.classList.remove(a);
                            });
                            const e = t.getBoundingClientRect(),
                                i = this.tabsWrapper.getBoundingClientRect(),
                                s = e.width,
                                n = e.left - i.left - parseFloat(getComputedStyle(this.tabsWrapper).paddingLeft);
                            this.classList.add(N),
                                this.tabActiveIndicator.classList.add(c),
                                (this.tabActiveIndicator.style.width = `${s}px`),
                                (this.tabActiveIndicator.style.transform = `translateX(${n}px)`),
                                setTimeout(() => {
                                    null !== this.tabActiveIndicator && (this.classList.remove(N), t.classList.add(a), this.tabActiveIndicator.classList.remove(c));
                                }, 600),
                                this.parentElement?.classList.add("has-shadow");
                        }
                    }
                }
                customElements.get("tabs-object") || customElements.define("tabs-object", D);
                const j = "data-section-initialized";
                class W {
                    static registrations = {};
                    static register(t, e) {
                        const i = [];
                        return (
                            document.querySelectorAll(t).forEach((s) => {
                                if (W.isRegistered(s)) return;
                                const a = new e(s, t);
                                i.push(a), a.queryChildren(s), a.init(), a.attachEvents(s);
                            }),
                                (this.registrations[t] = e),
                                i
                        );
                    }
                    static recheck(t) {
                        const e = this.registrations[t];
                        return e ? W.register(t, e) : [];
                    }
                    static isRegistered(t) {
                        return t.hasAttribute(j);
                    }
                    constructor(t, e) {
                        if (((this.container = t), (this.selector = e), this.container.setAttribute(j, "true"), (this.shopifyContainer = this.container.parentElement), this.shopifyContainer && this.shopifyContainer.id))
                            try {
                                this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
                            } catch (t) {
                                console.warn(t);
                            }
                        this.innerHtmlObserver = null;
                    }
                    replaceContainer(t) {
                        this.container.removeAttribute(j),
                            this.detatchEvents(this.container),
                            (this.container.innerHTML = t.innerHTML),
                            this.container.setAttribute(j, "true"),
                            this.queryChildren(this.container),
                            this.init(),
                            this.attachEvents(this.container);
                    }
                    init() {}
                    onInnerHtmlMutationObserved = (t, e) => {
                        if (!t.length) return;
                        if (!this.shopifyContainer) return;
                        const [i] = t,
                            s = [];
                        i.removedNodes.forEach((t) => s.push(t));
                        -1 !== s.findIndex((t) => t === this.shopifyContainer) && (console.log("Section", this.id, "reloaded."), this.dispose(), W.recheck(this.selector));
                    };
                    dispose() {
                        this.container.removeAttribute(j), this.detatchEvents(this.container), this.innerHtmlObserver && this.innerHtmlObserver.disconnect();
                    }
                }
                const z = (t, e) => {
                        let i = t.scrollLeft - 5;
                        for (let t = 0; t < e.length; t++) if (e[t].offsetLeft >= i) return t;
                        return e.length - 1;
                    },
                    F = (t) => {
                        let e = t.scrollWidth - t.clientWidth;
                        return t.scrollLeft > e - 50;
                    };
                W.register(
                    "[data-featured-products]",
                    class extends W {
                        tabsObject = null;
                        carousels = (() => new Map())();
                        activeCarouselIndex = 0;
                        queryChildren(t) {
                            (this.tabsObject = t.querySelector("tabs-object")), this.tabsObject && this.tabsObject.setCallback(this.onTabClick.bind(this));
                        }
                        attachEvents(t) {
                            const e = t.querySelectorAll("[data-carousel-collection]");
                            Array.from(e).forEach((t, e) => {
                                this.initCarousel(t), this.carousels.set(e, t.parentElement), 0 === e && t.parentElement?.classList.add("active");
                            }),
                                R();
                        }
                        detatchEvents() {}
                        initCarousel(t) {
                            const e = t.parentElement,
                                i = t.querySelectorAll("[data-carousel-tile]"),
                                s = e?.querySelector("[data-carousel-prev]"),
                                n = e?.querySelector("[data-carousel-next]"),
                                r = e?.querySelector("[data-carousel-progress]");
                            var l, o, c, d, u;
                            i &&
                            (((t, e, i, s) => {
                                let n,
                                    r,
                                    l = !1,
                                    o = !1;
                                e.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        l && t.preventDefault();
                                    });
                                }),
                                    t.addEventListener("mousedown", (e) => {
                                        (o = !0), t.classList.add(a), (n = e.pageX - t.offsetLeft), (r = t.scrollLeft);
                                    }),
                                    t.addEventListener("mouseleave", () => {
                                        (o = !1), (l = !1), t.classList.remove(a);
                                    }),
                                    t.addEventListener("mouseup", () => {
                                        (o = !1), t.classList.remove(a), setTimeout(() => (l = !1), 500);
                                    }),
                                    t.addEventListener("mousemove", (e) => {
                                        if (!o) return;
                                        l = !0;
                                        const i = 3 * (e.pageX - t.offsetLeft - n);
                                        (t.scrollLeft = r - i), t.setAttribute("data-scroll-left", (r - i).toString());
                                    }),
                                    t.addEventListener(
                                        "scroll",
                                        O(() => {
                                            let a = z(t, e);
                                            s && s(z(t, e)), i && (a + 1 >= e.length && !F(t) ? (i.style.width = (1 / e.length) * 100 + "%") : F(t) ? (i.style.width = "100%") : (i.style.width = ((a + 1) / e.length) * 100 + "%"));
                                        }, 50)
                                    );
                            })(t, i, r),
                            s &&
                            n &&
                            ((l = t),
                                (o = i),
                                (c = s),
                                (d = n),
                            (u = r) && (u.style.width = (1 / o.length) * 100 + "%"),
                                d.addEventListener("click", () => {
                                    let t = z(l, o);
                                    if (t + 1 >= o.length || F(l)) (l.scrollLeft = 0), u && (u.style.width = (1 / o.length) * 100 + "%");
                                    else {
                                        let e = 0;
                                        for (let i = 0; i <= t; i++) e += o[t].clientWidth;
                                        (l.scrollLeft = e), u && (u.style.width = ((t + 2) / o.length) * 100 + "%");
                                    }
                                }),
                                c.addEventListener("click", () => {
                                    let t = z(l, o);
                                    if (t <= 0) (l.scrollLeft = l.scrollWidth), u && (u.style.width = "100%");
                                    else {
                                        let e = 0;
                                        for (let i = 0; i < t - 1; i++) e += o[t].clientWidth;
                                        (l.scrollLeft = e), u && (u.style.width = (t / o.length) * 100 + "%");
                                    }
                                })));
                        }
                        onTabClick(t) {
                            if (this.activeCarouselIndex === t) return;
                            const e = this.getCarouselInstance(this.activeCarouselIndex);
                            e && e.classList.remove("active"), (this.activeCarouselIndex = t);
                            const i = this.getCarouselInstance(t);
                            i && i.classList.add("active");
                        }
                        getCarouselInstance(t) {
                            return this.carousels.get(t);
                        }
                    }
                );
            },
        },
        i = {};
    function s(t) {
        var a = i[t];
        if (void 0 !== a) return a.exports;
        var n = (i[t] = { exports: {} });
        return e[t].call(n.exports, n, n.exports, s), n.exports;
    }
    (s.m = e),
        (t = []),
        (s.O = function (e, i, a, n) {
            if (!i) {
                var r = 1 / 0;
                for (d = 0; d < t.length; d++) {
                    (i = t[d][0]), (a = t[d][1]), (n = t[d][2]);
                    for (var l = !0, o = 0; o < i.length; o++)
                        (!1 & n || r >= n) &&
                        Object.keys(s.O).every(function (t) {
                            return s.O[t](i[o]);
                        })
                            ? i.splice(o--, 1)
                            : ((l = !1), n < r && (r = n));
                    if (l) {
                        t.splice(d--, 1);
                        var c = a();
                        void 0 !== c && (e = c);
                    }
                }
                return e;
            }
            n = n || 0;
            for (var d = t.length; d > 0 && t[d - 1][2] > n; d--) t[d] = t[d - 1];
            t[d] = [i, a, n];
        }),
        (s.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        })()),
        (s.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (s.j = 6494),
        (function () {
            var t = { 6494: 0 };
            s.O.j = function (e) {
                return 0 === t[e];
            };
            var e = function (e, i) {
                    var a,
                        n,
                        r = i[0],
                        l = i[1],
                        o = i[2],
                        c = 0;
                    if (
                        r.some(function (e) {
                            return 0 !== t[e];
                        })
                    ) {
                        for (a in l) s.o(l, a) && (s.m[a] = l[a]);
                        if (o) var d = o(s);
                    }
                    for (e && e(i); c < r.length; c++) (n = r[c]), s.o(t, n) && t[n] && t[n][0](), (t[n] = 0);
                    return s.O(d);
                },
                i = (self.webpackChunkreflect_boilerplate = self.webpackChunkreflect_boilerplate || []);
            i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
        })(),
        s.O(void 0, [4121], function () {
            return s(6090);
        });
    var a = s.O(void 0, [4121], function () {
        return s(5092);
    });
    a = s.O(a);
})();
